import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const patchAdminDevice = async (deviceId, deviceData) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `legacy_admin/renolog/devices/${deviceId}`,
    body: deviceData,
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
